<template>
  <select v-model="model" @change="$emit('input', model);$emit('change', model)">

    <option :value="!value ? value : undefined" :disabled="!canSelectNull">{{ placeholder }}</option>

    <option v-for="x in languages" :key="x.code" :value="x.code" dir="ltr">
      {{ x.title }} - {{ x.native_title }} : {{ x.code }}
    </option>

  </select>
</template>

<script>
export default {
  name: "LanguageSelector",
  props: {
    value: {default: undefined},
    placeholder: {default: '--انتخاب زبان--'},
    noUserLanguage: {default: false},
    canSelectNull: {default: false}
  },
  data: () => ({
    model: undefined,
  }),
  watch: {
    value() {
      if (this.value !== this.model)
        this.model = this.value;
    }
  },
  computed: {
    languages() {
      return this.$store.getters['languages'] ? this.$store.getters['languages'].filter(x => {
        return !this.$store.getters['userPrivilegedLanguage'] ||
            this.$store.getters['userPrivilegedLanguage'].indexOf(x.code) >= 0
      }) : [];
    }
  },
  mounted() {
    this.$store.dispatch('retrieveLanguages').then(() => {
      const user_language = this.$store.getters.userLanguage;
      if (!this.noUserLanguage && user_language && !this.value && !this.model) {
        this.$emit('input', user_language);
        this.$emit('change', user_language);
      } else
        this.model = this.value;

      this.$emit('load')
    })
  }
}
</script>

<style scoped>

</style>
